<form #formContact="ngForm" (ngSubmit)="phoneCountryCode && formContact.form.valid && generateRecaptcha(formContact)" novalidate>
  <div class="form-row">
    <div class="col-12">
      <label class="control-label">{{"shared.contact_us.name" | translate}}</label>
      <input pInputText type="text" class="w-100" name="name" [(ngModel)]="contactData.name" #name="ngModel" [ngClass]="inputFieldCss(name, formContact)" app-onlyText required>
      <app-field-error-display [control]="name" [form]="formContact" [textColor]="textColor"></app-field-error-display>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12 col-xl-6">
      <label class="control-label">{{"shared.contact_us.email" | translate}}</label>
      <input pInputText type="email" class="w-100" name="email" [(ngModel)]="contactData.email" #email="ngModel" [ngClass]="inputFieldCss(email, formContact)" app-email required>
      <app-field-error-display [control]="email" [form]="formContact" [textColor]="textColor"></app-field-error-display>
    </div>

    <div class="col-12 col-xl-6 pl-xl-2">
      <label class="control-label">{{"shared.contact_us.phone" | translate}}</label>
      <div class="p-inputgroup">
        <div class="">
          <p-dropdown style="display: flex; width: inherit;" [options]="countryCodes" [(ngModel)]="phoneCountryCode" optionLabel="name" [showClear]="false"  [style]="{'font-size': '10px'}" (onChange)="setCountryCode();" [required]="true" name="phoneCountryCode">
            <ng-template pTemplate="selectedItem">
              <div class="row px-2" *ngIf="phoneCountryCode">
                <img
                  [src]="phoneCountryCode.flag"
                  height="20" />
                <div class="pr-1 pl-1">+{{ phoneCountryCode.dialCode }}</div>
              </div>
            </ng-template>
            <ng-template let-country pTemplate="item">
              <div class="row px-1"  style="flex-wrap:nowrap !important">
                <img
                  [src]="country.flag"
                  height="20"/>
                <div  class="pl-1"> {{country.name}}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <input pInputText type="tel" class="w-80" name="phone" [mask]="getCountryPhoneData(ePhoneCountries.USA, configurationService.application )?.mask" [(ngModel)]="contactData.phone" #phone="ngModel" [ngClass]="inputFieldCss(phone, formContact)" minlength="8" required>
      </div>
      <app-field-error-display [control]="phone" [form]="formContact" [textColor]="textColor"></app-field-error-display>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12">
      <label class="control-label" for="comments">{{"shared.contact_us.comments" | translate}}</label>
      <textarea class="form-control" id="comments" name="comments" [(ngModel)]="contactData.comments" #comments="ngModel" [ngClass]="inputFieldCss(comments, formContact)" required></textarea>
      <app-field-error-display [control]="comments" [form]="formContact" [textColor]="textColor"></app-field-error-display>
    </div>
  </div>
  <div class="form-row mt-2">
  </div>

  <div class="text-right">
    <button class="btn btn-light mt-4 pr-5 pl-5" type="submit">{{"shared.contact_us.send" | translate}}</button>
  </div>
</form>